import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment';

import { DATE_FORMAT } from '../../utils/constants';

interface PropTypes {
  date: Date | null | undefined;
}

export default function displayDate({ date }: PropTypes): JSX.Element {
  const dateString = date ? moment(date).format(DATE_FORMAT) : '';
  return <Container>{dateString}</Container>;
}

const Container = styled.div`
  margin: 0 3px;
  padding: 3px 6px;
  background: #f4f4f4;
  border-radius: 3px;
  font-size: 18px;
  font-weight: 500;
  width: fit-content;
`;
